<div [style.border-color]="profileBadgeConfiguration?.borderColour" class="profile-badge-border">
  <div [style.background-color]="profileBadgeConfiguration?.backgroundColour" class="profile-badge">
    <div *ngIf="initials !== ''; else cssBotImage" [style.color]="textColor" class="badge-text">{{ initials }}</div>
  </div>
</div>

<ng-template #cssBotImage>
  <div>
    <img class="bot-logo" [src]="'assets/logo/light/css-bot-logo.svg'" />
  </div>
</ng-template>
